function initializeRoutes() {
	var config = module.config();
	var signals = new CEventEmitter();

	var search = new ym.geo.CSearch();

	var searchSignals = new CSearchSignals(search, map, signals);

	var geocoder = new CGeocoderSignals(signals),
		Stations = [],
		geocoderTmpl = $('#geocoderListTpl').html(),
		routeListTmpl = $('#routeListTpl').html(),
		startInputTmpl = $('#startInputTpl').html();

	signals.once('maploaded', function () {
		CenterMarker(
			map.getCenter(),
			new ym.common.CIcon(
				'/presentation/filialfinder/areas/gtueMobile/content/img/gtue-logo_60.svg',
				{
					Width: 40,
					Height: 30
				},
				{ X: 20, Y: 15 }
			)
		);
	});

	signals.on('calcroutebefore', function () {
		$('.route-distance').text('bitte warten ...');
		$('.route-duration').text('bitte warten ...');
		signals.off('force-optimize');
	});

	signals.on('calcroutesuccess', function (geocoder, data, additions) {
		// Sollte die Geokodierung nicht eindeutig sein, wird eine Geocoder-Liste ausgegeben.
		if (data.RouteStartGeoItems && data.RouteStartGeoItems.length > 0) {
			$(
				_.template($.trim(geocoderTmpl))({
					geocoderList: _.map(data.RouteStartGeoItems, function (item) {
						if (!item.City && item.CityPart) item.City = item.CityPart;
						return item;
					})
				})
			).appendTo($('#content-geocoder').empty());
			$('.route-distance').text('keine Route ermittelbar');
			$('.route-duration').text('keine Route ermittelbar');
			return;
		}

		if (data.Route) {
			data.Color = new ym.common.CColor('#3344aa', 0.7);
			data.LineWidth = 5;

			$('.route-distance').text(
				(data.Route.Distance < 1000
					? data.Route.Distance + ' m'
					: (data.Route.Distance / 1000).toFixed(1) + ' km'
				)
					.toString()
					.replace('.', ',')
			);

			// Eine *genauere* Zeitangabe
			var timer;
			if (data.Route.Duration / 3600 > 1) {
				timer = moment()
					.add('hours', Math.floor(data.Route.Duration / 3600))
					.fromNow();
				if (data.Route.Duration % 3600 > 1800) {
					timer +=
						' und ' +
						moment()
							.startOf('hour')
							.add('seconds', data.Route.Duration % 3600)
							.minutes() +
						' Minuten';
				} else {
					timer +=
						' und ' +
						moment()
							.add('seconds', data.Route.Duration % 3600)
							.fromNow();
				}
			} else {
				timer = moment().add('seconds', data.Route.Duration).fromNow();
			}

			$('.route-duration').text(timer);

			map.removeAllMarkers();
			CenterMarker(
				map.getCenter(),
				new ym.common.CIcon(
					'/presentation/filialfinder/areas/gtueMobile/content/img/gtue-logo_60.svg',
					{
						Width: 40,
						Height: 30
					},
					{ X: 20, Y: 15 }
				)
			);

			var Markers = [];
			var TimeElapsed = 0;
			var lastWaypointIndex = data.Route.WayPointDescription.length - 1;

			// Startpunkt einfügen
			data.Route.WayPointDescription.unshift({
				GeoPoint: {
					X: data.Route.PolyLine[0].X,
					Y: data.Route.PolyLine[0].Y
				},
				NextDuration: 0,
				NextDistance: 0,
				Description: 'Startpunkt'
			});

			// Die Waypoints wurden um ein Elemente erweitert. Also
			// muss auch das lastWaypointIndex um 1 erhöht werden.
			++lastWaypointIndex;

			var routeList = _.map(data.Route.WayPointDescription, function (item, index) {
				var GeoPoint = new ym.g(item.GeoPoint.Y, item.GeoPoint.X),
					hideRouteInfo = false,
					index;

				if (index === 0) {
					Icon = new ym.common.CIcon(
						'/api_js/V1/Images/MapIcons/RouteStart.png',
						{ Width: 16, Height: 16 },
						{
							X: 8,
							Y: 8
						}
					);
					hideRouteInfo = true;
				} else if (index === lastWaypointIndex) {
					Icon = new ym.common.CIcon(
						'/Presentation/FilialFinder/Content/img/FlagRed.gif',
						{
							Width: 31,
							Height: 35
						},
						{ X: 9, Y: 33 }
					);
					item.Description = 'Sie haben Ihr Ziel erreicht.';
					hideRouteInfo = true;
				} else {
					Icon = new ym.common.CIcon(
						'/api_js/V1/Images/MapIcons/RouteWaypoint.png',
						{
							Width: 16,
							Height: 16
						},
						{ X: 8, Y: 8 }
					);
				}
				var MarkerSignals;

				TimeElapsed += item.NextDuration;

				var routeInfoObj = {
					Next:
						'nach ' +
						(item.NextDistance < 1000
							? item.NextDistance + ' m'
							: (item.NextDistance / 1000).toFixed(1) + ' km'),
					Description: item.Description,
					GeoPoint: item.GeoPoint
				};

				if (hideRouteInfo) {
					routeInfoObj.Next = '';
				}

				MarkerSignals = new CMarkerSignals(
					{
						Icon: Icon,
						Position: GeoPoint,
						LayerID: 'waypoint',
						OrdinalNumber: index,
						ZIndex: 1000
					},
					signals
				);

				MarkerSignals.marker.setInfoBoxOptions({
					Position: ym.map.INFO_BOX_POSITION.AUTO,
					ShowOnHover: true,
					ContentTemplate:
						'<div><div class="popup-item popup-route"><div><b>${Next}</b></div>${Description}</div></div>',
					Content: routeInfoObj
				});

				map.addMarker(MarkerSignals.marker);
				map.showMarker(MarkerSignals.marker);
				Markers.push(MarkerSignals.marker);

				return routeInfoObj;
			});

			$(_.template($.trim(routeListTmpl))({ routeList: routeList })).appendTo($('#content-routelist').empty());

			map.addRoute(data);
			map.showRoute(data);

			signals
				.on('force-optimize', function () {
					map.optimizeMapForResult(Markers);
					$('.route-optimize').hide();
				})
				.emit('force-optimize');
		}
	});

	signals.on('geocodesuccess', function (geocoder, data) {
		if (data.GeoItems && data.GeoItems.length === 1) {
			var item = data.GeoItems[0];

			$('#content-geocoder').empty().hide();
			$('#content-routelist').show();
			$('#routes').show();

			$('.route-from').text(ym.util.formatAddressLine(item));
			if (Stations.length === 2) {
				Stations.shift();
			}
			Stations.unshift(new ym.g(item.LocY, item.LocX));
			if (Stations.length === 1) {
				searchSignals.searchByIdentifier(config.YMID, {
					Country: 'DE',
					Addition: config.Addition
				});
			} else {
				geocoder.calcRoute(Stations);
			}
		} else {
			var $geocoderList = $('#content-geocoder');
			$geocoderList.show();
			$('#content-routelist').hide();
			$('#routes').hide();
			$(
				_.template($.trim(geocoderTmpl))({
					geocoderList: _.map(data.GeoItems, function (item) {
						if (!item.City && item.CityPart) item.City = item.CityPart;
						return item;
					})
				})
			).appendTo($geocoderList.empty().show());
		}
	});

	signals.on('searchsuccess', function (data) {
		if (data.AddressItems && data.AddressItems.length === 1) {
			var Poi = data.AddressItems[0];

			$('.route-to').text(ym.util.formatAddressLine(Poi.BasicData.Address));

			// Einmalig die Geo-Position der Filiale eintragen.
			Stations.push(new ym.g(Poi.BasicData.Geo.YCoord, Poi.BasicData.Geo.XCoord));

			geocoder.calcRoute(Stations);
		}
	});

	signals.on('markerclick', function (marker, clickEvent) {
		map.setCenterAndZoom(clickEvent.GeoPosition, 17);
	});

	// Damit der Nutzer stets wieder zur eigentlichen
	// Route zurück kehren kann :-)
	signals.on('mapendmove', function () {
		$('.route-optimize').show();
	});

	$(document).on('click', '.route-optimize', function (e) {
		e.preventDefault();
		signals.emit('force-optimize');
	});

	$(document).on('click', '.routelist > li', function (e) {
		var X = $(this).attr('data-x'),
			Y = $(this).attr('data-y');

		$('#content-geocoder').empty().hide();
		$('#content-routelist').show();
		$('#routes').show();

		map.setCenterAndZoom(new ym.g(Y, X), 17);
	});

	$(document).on('click', '.geocoder-list > ul > li > a', function (e) {
		e.preventDefault();
		var lng = $(this).attr('data-locx'),
			lat = $(this).attr('data-locy'),
			address = $(this).attr('data-address');

		var $routeFrom = $('.route-from');
		$('#content-geocoder').empty().hide();
		$('#content-routelist').show();
		$('#routes').show();

		$routeFrom.text(address);
		if (Stations.length === 2) {
			Stations.shift();
		}
		Stations.unshift(new ym.g(lat, lng));
		if (Stations.length === 1) {
			searchSignals.searchByIdentifier(config.YMID, {
				Country: 'DE',
				Addition: config.Addition
			});
		} else {
			geocoder.calcRoute(Stations);
		}
	});

	if (config.SourceX && config.SourceY) {
		setTimeout(function () {
			signals.emit('geocodesuccess', geocoder, {
				GeoItems: [
					{
						City: config.SingleSlotGeo,
						LocX: config.SourceX,
						LocY: config.SourceY
					}
				]
			});
		}, 0);
	} else if (config.SingleSlotGeo) {
		geocoder.geocodeString(config.SingleSlotGeo);
	} else {
		var $content = $('#content-geocoder');
		$content.show();
		$('#content-routelist').hide();
		$('#routes').hide();
		$($.trim(startInputTmpl)).appendTo($content.empty().show());
		var startInput = $content.find('#startPosition')[0];

		if (!ym.modules.autoComplete && sm.autocomplete.v5) {
			ym.modules.autoComplete = sm.autocomplete.v5.autoComplete;
		}

		var ac = ym.modules.autoComplete(startInput, { locales: ['de'] });
		var form = $(ac.element).closest('form')[0];

		function setInputValue(name, value) {
			var input = form.querySelector('[name="' + name + '"]');
			if (input) {
				input.value = value;
			}
		}

		ac.on('selected', function (item) {
			setInputValue('SourceX', item.geometry.coordinates[0]);
			setInputValue('SourceY', item.geometry.coordinates[1]);
			$(ac.element).closest('form').submit();
		});

		ac.element.addEventListener('input', function () {
			if (ac.element.value.trim() === '') {
				setInputValue('SourceX', '');
				setInputValue('SourceY', '');
			}
		});
	}

	map.loadMap();
}

ym.ready({ autocomplete: 5 }, function () {
	if (!ym.modules.autoComplete && sm.autocomplete.v5) {
		ym.modules.autoComplete = sm.autocomplete.v5.autoComplete;
	}
	initializeMap();
	initializeRoutes();
});
